import { useState } from "react";
import { useDispatch } from "react-redux";

import TextField from "../../../Components/common/TextField/TextField";
import FileCardButton from "../../../Components/UI/FileCardButton/FileCardButton";
import Warning from "../../../Components/common/Warning/Warning";
import Success from "../../../Components/common/Warning/Success";
import SandboxVisitConfirm from "../../../Components/common/SandboxVisit/SandboxVisitConfirm";

import WebIcon from "../../../Components/Icon-SVG/WebIcon";
import CameraIcon from "../../../Components/Icon-SVG/CameraIcon";
import axiosApi from "../../../utils/axios";
import { URL_REGEX } from "../../../utils/constants/regex";

import { RequestPhishBoxList } from "../../../store/actions/phishBoxActions";

const SubmitCard = () => {
  const dispatch = useDispatch();
  const [url, setUrl] = useState("");
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showVisitConfirm, setShowVisitConfirm] = useState(false);

  // Visiting opens the submitted page in a new tab of the user's own browser,
  // so nothing happens until they confirm it. An invalid URL is reported
  // straight away instead of being asked about first.
  const requestVisitHandler = () => {
    if (!URL_REGEX.test(url)) {
      setError(`${url} is not a valid URL.`);
      setShow(true);
      return;
    }

    setShowVisitConfirm(true);
  };

  const visitHandler = async () => {
    try {
      const response = await axiosApi.get(
        `/api/phishbox/url-rewrite?url=${encodeURIComponent(url)}`,
      );
      const rewritedUrl = response?.data?.url;
      if (rewritedUrl) {
        window.open(`/psh1/view?u=${rewritedUrl}`, "_blank");
        dispatch(RequestPhishBoxList());
        setUrl("");
      } else {
        setError(`Failed to visit ${url}`);
        setShow(true);
      }
    } catch (e) {
      setError("Unexpected error");
      setShow(true);
    }
  };

  const undattenedHandler = async () => {
    if (!URL_REGEX.test(url)) {
      setError(`${url} is not a valid URL.`);
      setShow(true);
      return;
    }

    try {
      const query = new URLSearchParams({
        url: url, // Encode the URL parameter
        host: window.location.origin, // Current window host
      });

      const response = await axiosApi.get(`/api/phishbox/url-unattended?${query.toString()}`);

      const rewritedUrl = response?.data?.url;
      if (rewritedUrl) {
        setSuccess("URL submitted successfully for unattended analysis.");
        setShow2(true);
        dispatch(RequestPhishBoxList());
        setUrl("");
      } else {
        setError(`Failed to visit ${url}`);
        setShow(true);
      }
    } catch (e) {
      setError("Unexpected error");
      setShow(true);
    }
  };

  return (
    <div className="phishbox__submit-card border">
      <div className="phishbox__submit-card__wrapper">
        <p>Submit URL for analysis:</p>
        <TextField
          placeholder="https://www.test.com/malicious"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          name="appName"
        />
        <div style={{ display: "flex", gap: "8px" }}>
          <FileCardButton onClick={requestVisitHandler}>
            <WebIcon width={21} height={21} color="white" />
            <p>Visit</p>
          </FileCardButton>
          <FileCardButton onClick={undattenedHandler} width={90}>
            <CameraIcon width={22} height={22} />
            <p>Unattended</p>
          </FileCardButton>
        </div>
      </div>
      <SandboxVisitConfirm
        url={url}
        show={showVisitConfirm}
        setShow={setShowVisitConfirm}
        onConfirm={visitHandler}
      />
      <Warning
        onClickOk={() => setShow(false)}
        show={show}
        setShow={setShow}
        text={error}
        article="Warning"
        cancelDisable={true}
        textOK="Okay"
      />
      <Success
        onClickOk={() => setShow2(false)}
        show={show2}
        setShow={setShow2}
        text={success}
        article="Submitted"
        cancelDisable={true}
        textOK="Okay"
      />
    </div>
  );
};

export default SubmitCard;
